import * as _ from 'underscore';

var _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    //LL: 21.07.20: move 'Entity Color' to commonTheme.ts  ------------------------------
    //              So, no duplication now   --------------------------------------------

    //LL: 28.01.20: rename to 'Mappings'
    //LL: 17.09.19:  rename by Leo's request, don't forget in commonTheme
    //LL: 06.02.18: parent node for 'ColorScales' (defined in pdc-platform/ts/themes/commonTheme) and 'Entity Color'
    //     duplicate, so parent already exists

    //appTheme.registerSections(
    //    [
    //        {
    //            id: 'colorMapping',
    //            name: 'Mappings',  //'Color and Mappings', // 'Color Mapping',
    //            themeType: 'ColorMapping',
    //            visibility: [
    //                'application',
    //                'workspace',
    //                'widget'
    //            ]
    //        }
    //    ]
    //);

    //appTheme.registerSections(
    //    [
    //        {
    //            id: 'entities-model',
    //            //name: 'Entity Color',
    //            //name: 'Color Lookup Tables', //LL: 06.02.18: Leo's request
    //            name: 'Colors for Entities and Attributes', //LL: 30.11.19: Leo's request 'Specifying Colors for Entities and Attributes'
    //            parent: 'colorMapping', //LL: 06.02.18
    //            explanation: "Mapping individual Attribute Values to Colors",  //LL: 06.02.18
    //            themeType: 'Entity Color',
    //            visibility: [
    //                'application',
    //                'workspace',
    //                'widget'
    //            ]
    //        }
    //    ]
    //);

    //appTheme.registerVars(
    //    [
    //        {
    //            id: 'entities-model-color-mapping',
    //            param: new EntityColorSelect(
    //                glob, 'Color Mapping', [],
    //                function (theme) {
    //                    return {};
    //                },
    //                {
    //                }
    //            ),
    //            section: 'entities-model',
    //            merger: (src, obj: any) => {
    //                src = _.clone(src);
    //
    //                // remove all color definitions from SRC for attribute that are redefined in OBJ
    //                let src_1 = _.reject(
    //                    src,
    //                    (src_item: any) => {
    //                        return (
    //                            _.find(
    //                                obj,
    //                                (obj_item: any) => {
    //                                    return (obj_item.attribute === src_item.attribute)
    //                                }
    //                            ) != null
    //                        )
    //                    }
    //                )
    //
    //                // Concat remainders
    //                return src_1.concat(obj);
    //
    //
    //                // --------- OLD TARAS CODE ----------
    //                // _.reduce(
    //                //     _.keys(obj),
    //                //     (res: any, key: string) => {
    //                //         if (res[key] == null) {
    //                //             res[key] = _.clone(obj[key]);
    //
    //                //         } else {
    //                //             res[key] = _.extend(
    //                //                 {},
    //                //                 res[key],
    //                //                 obj[key]
    //                //             );
    //                //         }
    //
    //                //         return res;
    //                //     },
    //                //     src
    //                // );
    //            },
    //            deps: []
    //        }
    //    ]
    //);

    _init.push(glob);
}
